export default "__VITE_ASSET__oYViKmEN__"